import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material/material.module';
import { ThemeCardComponent } from './theme-card.component';

@NgModule({
  declarations: [ThemeCardComponent],
  imports: [CommonModule, MaterialModule],
  exports: [ThemeCardComponent],
})
export class ThemeCardModule {}
